














































































  /* eslint-disable no-console */

  import {EditionDTO, ArtefactTextFragmentMatchDTO, CatalogueMatchDTO} from "../dtos/sqe-dtos";
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
  import _ from 'lodash';

@Component({
  filters: {
    formatRef: function (value: CatalogueMatchDTO): string {
      if (!value) return ''
      return `${value.imagedObjectId}, ${value.editionName} ${value.editionVolume} ${value.editionLocation1} ${value.editionLocation2} ${value.editionSide} = QWB ${value.name} `
    },
    shortRef: function (value: CatalogueMatchDTO): string {
      if (!value) return ''
      return `${value.imagedObjectId} / QWB ${value.name} (${value.editionLocation2})`
    }
  }
})
export default class MatchChooser extends Vue {
  selectedMatch = {} as CatalogueMatchDTO
  showConfirmed = true
  showRejected = false
  currentIndex = 0

  get matches(): CatalogueMatchDTO[] {
    return this.$store.state.matches
  }

  set matches(matches: CatalogueMatchDTO[]) {
    this.$store.commit('matchesSet', matches)
  }

  get filteredMatches(): CatalogueMatchDTO[] {
    return this.matches.filter((x: CatalogueMatchDTO) => this.showMatch(x))
  }

  async mounted() {
    document.addEventListener("keyup", event => {
      if (event.isComposing || event.keyCode === 229) {
        return;
      }
      else if (event.altKey && event.keyCode === 37) this.prev()
      else if (event.altKey && event.keyCode === 39) this.next()
    })

    this.$root.$on('reload-matches', () => {
      this.getMatches()
    });

    try {
      const res = await this.$com.sqeComms?.getV1Editions(true, false)
      if (res !== undefined)
        this.$store.commit('scrollsSet', res.editions.map(x => x.filter(y => y.isPublic)).flat().sort((a, b) => a.name.localeCompare(b.name, 'en', { numeric: true })))
    } catch(err) {
      console.error(err)
    }
  }

  next() {
    if (this.filteredMatches.length > 2) {
      const side = this.selectedMatch.editionSide
      do {
        this.currentIndex = (this.currentIndex + 1) % this.matches.length
        this.selectedMatch = this.matches[this.currentIndex]
      } while (!this.showMatch(this.selectedMatch) || this.selectedMatch.editionSide !== side)
      this.setNewMatch(this.selectedMatch)
    }
  }

  prev() {
    if (this.filteredMatches.length > 2) {
      const side = this.selectedMatch.editionSide
      do {
        this.currentIndex = this.currentIndex - 1 < 0 ? this.matches.length - 1 : this.currentIndex - 1
        this.selectedMatch = this.matches[this.currentIndex]
      } while (!this.showMatch(this.selectedMatch) || this.selectedMatch.editionSide !== side)
      this.setNewMatch(this.selectedMatch)
    }
  }

  showMatch(match: CatalogueMatchDTO): boolean {
    return match.confirmed === null
            || (match.confirmed === false && this.showRejected)
            || (match.confirmed === true && this.showConfirmed)
  }

  async getMatches() {
    if(this.$store.state.selectedEdition.id) {
      try {
        const res = await this.$com.sqeComms?.getV1CatalogueEditionsEditionIdImagedObjectTextFragmentMatches(this.newEdition.id)
        if (res) {
          this.matches = _.sortBy(_.uniqBy(res.matches, 'matchId'), ['name', 'imagedObjectId', 'catalogSide'])
        }
      } catch (err) {
        console.error(err)
      }
    }
  }

  get newEdition(): EditionDTO{
    return this.$store.state.selectedEdition
  }

  set newEdition(newVal: EditionDTO) {
    this.$store.commit('selectedEditionSet', newVal)
    this.$store.commit('scroll_idSet',newVal.id)
    this.$store.commit('manuscript_nameSet', newVal.name)
  }

  get newMatch(){
    return this.selectedMatch
  }

  set newMatch(newVal: CatalogueMatchDTO) {
    this.selectedMatch = newVal
    this.currentIndex = this.matches.indexOf(this.selectedMatch)
    this.setNewMatch(newVal)
  }

  setNewMatch(newVal: CatalogueMatchDTO) {
    this.$store.commit('scroll_idSet', newVal.editionId)
    this.$store.commit('image_catalog_idSet', newVal.imagedObjectId)
    this.$store.commit('imageSideSet', newVal.catalogSide?.toString())
    this.$store.commit('imageInfoSet', newVal.imagedObjectId)
    this.$store.commit('edition_catalog_idSet', newVal.iaaEditionCatalogueId)
    this.$store.commit('edition_nameSet', newVal.editionName)
    this.$store.commit('edition_volumeSet', newVal.editionVolume)
    this.$store.commit('edition_location_1Set', newVal.editionLocation1)
    this.$store.commit('edition_location_2Set', newVal.editionLocation2)
    this.$store.commit('edition_sideSet', newVal.editionSide)
    this.$store.commit('col_idSet', newVal.textFragmentId)
    this.$store.commit('colInfoSet', newVal.name)
    this.$store.commit('confirmed_by_nameSet', newVal.matchAuthor !== null ? newVal.matchAuthor : undefined)
    this.$store.commit('confirmedSet', newVal.confirmed)
    this.$store.commit('matchIdSet', newVal.matchId)
  }

  findCurrentSelection(){
    const selectionCandidates = this.matches.filter(x =>
            x.imagedObjectId === this.$store.state.image_catalog_id
            && x.textFragmentId === this.$store.state.col_id
            && x.catalogSide?.toString() === this.$store.state.imageSide
            && x.editionSide.toString() === this.$store.state.edition_side)
    if (selectionCandidates.length > 0)
      this.selectedMatch = selectionCandidates[0]
    this.currentIndex = this.matches.indexOf(this.selectedMatch)

    if (this.selectedMatch.editionId !== this.newEdition.id) {
      const edition = this.$store.state.scrolls.filter((x: EditionDTO) => x.id === this.newEdition.id)
      if (edition.length > 0)
        this.newEdition = edition[0]
    }
  }

  logout() {
    window.localStorage.removeItem('jwt')
    this.$store.commit('session_idSet', null)
    this.$store.commit('user_nameSet',null)
    this.$router.push('/')
  }

  @Watch('$store.state.matches')
  matchesChanged(){
    this.findCurrentSelection()
  }

  @Watch('$store.state.selectedEdition')
  editionIdChanged(newVal: EditionDTO, oldVal: EditionDTO) {
    if (newVal !== oldVal) {
      this.getMatches()
    }
  }

  @Watch("$store.state.requestMatchChooserReload")
  refreshMatchCalled(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal && newVal === true) {
      this.getMatches()
      this.$store.commit('matchChooserReloadSet', false)
    }
  }
}
